import {
    useStyles,
    Caption,
    Checkbox,
    pxToRem,
    useTheme,
} from '@archipro-design/aria';
import * as S from './FilterContainer.mobile.style';
import FilterAccordion from './FilterAccordion';
import type { AccordionPanel } from './FilterAccordion';
import type { FilterSortOption } from '~/modules/search';
import type { SortOption } from '~/modules/search/hook/use-search-sorts';

export interface FilterSortByProps {
    sortOptions: SortOption[];
    onSortChange: (sort: FilterSortOption) => void;
}

const FilterSortBy = ({ sortOptions, onSortChange }: FilterSortByProps) => {
    const theme = useTheme();
    const { css } = useStyles();

    const selectedSort = sortOptions.find((s) => s.selected);

    const panels: AccordionPanel[] = [
        {
            title: {
                title: 'Sort options',
                key: 'sort-by',
                applied: !!selectedSort,
                appliedFilters: selectedSort
                    ? [
                          {
                              key: 'sort-by',
                              label: selectedSort.name,
                              action: () => {},
                          },
                      ]
                    : [],
            },
            content: (
                <div>
                    {sortOptions.map((s) => (
                        <Checkbox
                            key={s.value}
                            checked={s.selected}
                            onChange={() => onSortChange(s.value)}
                            indicator={{
                                kind: 'radio',
                                indicator: {
                                    variables: {
                                        border: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
                                        size: pxToRem(14),
                                        checkedBackgroundColor:
                                            theme.siteVariables.colors
                                                .charcoal[250],
                                    },
                                },
                            }}
                            label={{
                                children: s.name,
                                variables: {
                                    fontSize: pxToRem(16),
                                    letterSpacing: 'normal',
                                },
                            }}
                            variables={{
                                labelLineHeight: pxToRem(40),
                                radioIndicatorLabelGap: pxToRem(6),
                                radioIndicatorLabelCheckedGap: pxToRem(6),
                            }}
                        />
                    ))}
                </div>
            ),
            activePanel: false,
        },
    ];

    return (
        <div className={css(S.SortByContainer)}>
            <Caption variant="03" className="sort-by-title">
                SORT BY
            </Caption>
            <FilterAccordion panels={panels} />
        </div>
    );
};

export default FilterSortBy;
